export const COOKIE_CONSENT_STORAGE_KEY = "pft_cookie_consent_v1";

export const COOKIE_CATEGORIES = {
  ESSENTIAL: "essential",
  ANALYTICS: "analytics",
  MARKETING: "marketing",
};

export const DEFAULT_COOKIE_CONSENT = {
  status: "pending",
  categories: {
    [COOKIE_CATEGORIES.ESSENTIAL]: true,
    [COOKIE_CATEGORIES.ANALYTICS]: false,
    [COOKIE_CATEGORIES.MARKETING]: false,
  },
  updatedAt: null,
};

export const readCookieConsent = () => {
  try {
    const rawValue = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!rawValue) return DEFAULT_COOKIE_CONSENT;

    const parsed = JSON.parse(rawValue);
    if (!parsed || typeof parsed !== "object") return DEFAULT_COOKIE_CONSENT;

    return {
      ...DEFAULT_COOKIE_CONSENT,
      ...parsed,
      categories: {
        ...DEFAULT_COOKIE_CONSENT.categories,
        ...(parsed.categories || {}),
      },
    };
  } catch (_error) {
    return DEFAULT_COOKIE_CONSENT;
  }
};

export const saveCookieConsent = (consentData) => {
  const normalized = {
    ...DEFAULT_COOKIE_CONSENT,
    ...consentData,
    categories: {
      ...DEFAULT_COOKIE_CONSENT.categories,
      ...(consentData?.categories || {}),
      [COOKIE_CATEGORIES.ESSENTIAL]: true,
    },
    updatedAt: new Date().toISOString(),
  };

  window.localStorage.setItem(
    COOKIE_CONSENT_STORAGE_KEY,
    JSON.stringify(normalized)
  );

  window.dispatchEvent(
    new CustomEvent("cookie-consent-updated", {
      detail: normalized,
    })
  );

  return normalized;
};

export const hasCookieConsentFor = (category) => {
  const consent = readCookieConsent();
  return Boolean(consent.categories?.[category]);
};

